import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, Sort } from "@preveil-api";
import { DriveUIActionTypes, getSelectedState, SORT_DIRECTION } from "src/common";
import { Checkbox, EmptyView, Loading, Icon } from "src/components";
import { ListRow } from "..";
import _ from "lodash";

type AllProps = {
  is_loading: boolean;
  address_list: string[];
  selected: string[];
  sort: Sort<string>;
  handleAction: ActionHandlerFunction;
};

// Description: ListViewComponent is a component that renders a list view in the email gateway page.
// It displays a list of email addresses or domains and allows the user to select them.
function ListViewComponent(props: AllProps) {
  const { is_loading, selected, address_list, sort, handleAction } = props;

  // Description: Render the rows of Admin Users view
  function RenderList(_list: string[]) {
    return (
      <div className="list-body">
        {_.map(_list, (_address: string, i: number) => {
          return (
            <ListRow
              key={`item_${i}`}
              address={_address}
              handleAction={handleAction}
              selected={selected.includes(_address)}
            />
          );
        })}
      </div>
    );
  }

  // Description: Handles Sorting
  function handleSort(field: string) {
    handleAction({ actionType: DriveUIActionTypes.SetSort, params: field });
  }

  return (
    <div className={`admin-list-view admin-users ${is_loading ? " isloading" : ""}`}>
      {!!address_list && address_list.length > 0 && (
        <Row className="header-row">
          <Col md="1">
            <Checkbox
              className="sr-only"
              onChange={(e: FocusEvent<HTMLInputElement>) => {
                handleAction({
                  actionType: DriveUIActionTypes.Select,
                  params: { selected: e.target.checked },
                });
              }}
              value="all"
              label="Select All"
              selected={getSelectedState(selected, address_list.length)}
            />
          </Col>
          <Col md="5" className="col" onClick={() => handleSort("address")}>
            Email Address/Domain
            {!!sort && sort.field === "address" && address_list.length > 0 && (
              <Icon className={`${sort.direction === SORT_DIRECTION.descending ? "ficon-arrow-down" : "ficon-arrow-up"} small-icon ps-1`} />
            )}
          </Col>
        </Row>
      )}
      {!!address_list && address_list.length > 0 ? (
        RenderList(address_list)
      ) : !is_loading ? <EmptyView message="No matches found!" /> : null}

      {is_loading && <Loading />}
    </div>
  );
}

export default React.memo(ListViewComponent);
